import { render } from "./AllDistricts.vue?vue&type=template&id=6cc7a331&scoped=true"
import script from "./AllDistricts.vue?vue&type=script&lang=js"
export * from "./AllDistricts.vue?vue&type=script&lang=js"

import "./AllDistricts.vue?vue&type=style&index=0&id=6cc7a331&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc7a331"]])

export default __exports__